import { PopupError } from "@components/general/popup";
import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import { PiArrowsLeftRightDuotone, PiListChecksDuotone } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

export const SubmenuPaymentPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  const [popupError, setPopupError] = useState<boolean>(false);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Pembayaran",
    });
  }, [setHeader]);
  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-0 menu">
        <div className="card-body-grid">
          <div className="card-grid">
            <div
              onClick={
                () =>
                  navigate(
                    linkPage.FINANCE_REQUEST_VA.replace(":type", "bill"),
                    {
                      state: {
                        tagihan: true,
                        tipe: "bill",
                      },
                    },
                  )
                // setPopupError(true)
              }
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
              <PiArrowsLeftRightDuotone className="card-icon tw-text-[#4D8EFF]" />
              <div className="card-name">Request Va</div>
            </div>
          </div>

          {/* <div className="card-grid">
          <div
            onClick={() =>
              navigate(
                linkPage.FINANCE_REQUEST_VA.replace(":type", "non-monthly"),
                {
                  state: {
                    tagihan: true,
                    tipe: "sekali",
                  },
                }
              )
            }
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
            <PiArrowsLeftRightDuotone className="card-icon tw-text-[#4D8EFF]" />
            <div className="card-name">VA Non Bulanan</div>
          </div>
        </div> */}

          {/* <div className="card-grid">
          <div
            onClick={() =>
              navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "debt"), {
                state: {
                  tagihan: true,
                  tipe: "utang",
                },
              })
            }
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
            <PiArrowsLeftRightDuotone className="card-icon tw-text-[#4D8EFF]" />
            <div className="card-name">VA Utang</div>
          </div>
        </div> */}

          <div className="card-grid">
            <div
              onClick={() =>
                navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "zis"), {
                  state: {
                    tagihan: false,
                    // tipe: "zis",
                  },
                })
              }
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
              <PiArrowsLeftRightDuotone className="card-icon tw-text-[#4D8EFF]" />
              <div className="card-name">VA ZIS</div>
            </div>
          </div>

          {/* <div className="card-grid">
          <div
            onClick={() =>
              navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "pocket"), {
                state: {
                  tagihan: false,
                  tipe: "",
                },
              })
            }
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#e0f9f2]" />
            <PiMoneyDuotone className="card-icon tw-text-[#00b894]" />
            <div className="card-name">VA Uang Saku</div>
          </div>
        </div> */}
          {/* <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.DEBT_PAYMENT_PAGE)}
            className="tw-m-0"
          >
            <FcHighPriority
              className="card-icon"
              style={{ background: "#eee" }}
            />
            <div className="card-name">Utang</div>
          </div>
        </div> */}

          <div className="card-grid">
            <div
              onClick={() => navigate("/finance/data-va")}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
              <PiListChecksDuotone
                className="card-icon"
                // style={{ background: "#e0f9f2" }}
              />
              <div className="card-name">Laporan</div>
            </div>
          </div>
        </div>
      </div>

      <PopupError
        open={popupError}
        title="Fitur Tidak Tersedia"
        message="Fitur ini sedang dalam perbaikan. Kami akan segera mengaktifkannya kembali."
        textConfirm="Tutup"
        onConfirm={() => setPopupError(false)}
      />
    </>
  );
};
